export const KEY = '---------';

export default function separatorItem() {
  return {
    name: KEY
  };
}



// WEBPACK FOOTER //
// ./src/plugins/contextMenu/predefinedItems/separator.js